import Checkbox from '@base/Checkbox/Checkbox';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { FC } from 'react';
import { weekDayWithValues } from '@utils/dates';

const DayContainer = styled.div`
  margin-bottom: ${Spacings.SPACING_8B};
`;

const WeekDaysContainer = styled.div`
  margin-top: ${Spacings.SPACING_12B};
`;

interface ISelectDaySectionProps {
  days: number[];
  handleUpdateDays: (updatedDays: number[]) => void;
}

const SelectDaysSection: FC<ISelectDaySectionProps> = ({
  days,
  handleUpdateDays
}) => {
  const handleUpdateDaySelection = (ev) => {
    const dayIndex = +ev.target.value;
    let updatedDays = [...days];
    if (updatedDays.includes(dayIndex)) {
      updatedDays = updatedDays.filter((x) => x !== dayIndex);
    } else {
      updatedDays.push(dayIndex);
    }
    updatedDays = updatedDays.sort((a, b) => a - b);
    handleUpdateDays(updatedDays);
  };
  return (
    <WeekDaysContainer>
      {weekDayWithValues.map((currentDayData) => (
        <DayContainer key={currentDayData.value}>
          <Checkbox
            value={`${currentDayData.value}`}
            label={currentDayData.label}
            checked={days.includes(currentDayData.value)}
            color="var(--color-text-primary)"
            onChange={handleUpdateDaySelection}
          />
        </DayContainer>
      ))}
    </WeekDaysContainer>
  );
};

export default SelectDaysSection;
